<!-- 优惠券列表 -->
<template>
  <div class="listBox">
    <div class="header">
      <span>优惠券列表</span>
    </div>
    <div class="couponList">
      <template v-if="dataList && dataList.length">
        <div class="couponLi" v-for="item in dataList" :key="item.id">
          <!-- 限制时间 -->
          <div class="limit-con" v-if="item.get_condition != 1">
            <span v-if="item.get_condition == 2">{{
              `观看${item.is_satisfy ? item.watch_time : item.lookTime}/${
                item.watch_time
              }分钟`
            }}</span>
            <span v-else>观看至下播</span>
          </div>
          <!-- end -->
          <div :class="item.description ? 'top' : 'toplist'">
            <div class="top-left">
              <span>{{ formatNumber(item.face_value, item.type) }}</span>
              <!-- class="money" -->
              <span v-if="item.type == 1" class="money">元</span>
              <span v-if="item.type == 2" class="money">折</span>
            </div>
            <div class="top-right">
              <div class="titleBox">
                <p class="title">{{ item.name }}</p>
                <template>
                  <p
                    v-if="item.get_condition != 1 && !item.is_satisfy"
                    class="btn"
                    @click="$emit('closeCouponsList')"
                  >
                    去观看
                  </p>
                  <p
                    v-else-if="item.state == 0"
                    class="btn"
                    @click="receiveCoupon(item)"
                  >
                    立即领取
                  </p>
                  <p
                    v-else-if="item.state == 1"
                    class="btn touse"
                    @click="gotoUse(item)"
                  >
                    去使用
                  </p>
                  <p v-else-if="item.state == 2" class="btn claimed">已领完</p>
                  <p v-else-if="item.state == 3" class="btn claimed">已使用</p>
                </template>
              </div>
              <div class="time">
                <!-- <p>开始时间：{{ item.start_time || '----' }}</p>
                <p style="margin-top: 6px;">结束时间：{{ item.end_time || '----' }}</p> -->
                {{ formatNumberlist(item.start_time) }} -
                {{ formatNumberlist(item.end_time) }}
              </div>
              <div v-if="item.state == 1" class="checkCode">
                <p>
                  核销码：<span>{{
                    item.isCode ? item.verification_code : "**********"
                  }}</span>
                </p>
                <div class="operation">
                  <img
                    class="curImg"
                    :src="
                      item.isCode
                        ? require('@/assets/imgs/viewOpen.png')
                        : require('@/assets/imgs/viewClose.png')
                    "
                    @click="isShowHide(item, 'isCode')"
                    alt=""
                  />
                  <img
                    class="curImg"
                    src="@/assets/imgs/copy.png"
                    @click="copyTextTap(item.verification_code)"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
          <!-- 分割线 -->
          <div class="line-con" v-if="item.description">
            <div class="banyuaner"></div>
            <div class="banyuan"></div>
          </div>
          <div class="bottom">
            <span
              v-if="item.description"
              :class="[
                item.description && item.description.length > 50 && !item.isUp
                  ? 'whiteSpace'
                  : '',
              ]"
            >
              使用规则：{{ item.description || "------" }}
            </span>
            <img
              v-if="item.description && item.description.length > 50"
              class="curImg"
              :src="
                !item.isUp
                  ? require('@/assets/imgs/select_up.png')
                  : require('@/assets/imgs/select_down.png')
              "
              alt=""
              @click="isShowHide(item, 'isUp')"
            />
          </div>
        </div>
      </template>
      <div v-else class="empty-data">
        <img src="@/assets/imgs/kong1.png" />
        <span class="empty-text">暂无优惠券</span>
      </div>
    </div>
  </div>
</template>

<script>
import tool from "@/kits/Tools.js";
import qs from "qs";
import { formatNumber, compareDate } from "@/utils";
export default {
  name: "CouponList",
  props: ["dsId", "channelId"],
  data() {
    return {
      dataList: [],
      watchData: {},
      lookingTime: 0,
      setLookTime: null,
    };
  },
  watch: {
    lookingTime(newV) {
      if (newV) {
        const totalTime = this.watchData.second_time || 0 + newV;
        console.log(this.watchData.second_time, newV, "计时时长");
        this.dataList.forEach((ele) => {
          if (ele.get_condition == 2 && !ele.is_satisfy) {
            if (ele.watch_time * 60 <= totalTime) {
              ele.lookTime = ele.watch_time;
              ele.is_satisfy = true;
            } else {
              ele.lookTime =
                Math.floor(totalTime / 60) < 0 ? 0 : Math.floor(totalTime / 60);
              ele.is_satisfy = false;
            }
          }
        });
      }
    },
  },
  methods: {
    formatNumberlist(item) {
      return item.substring(0, 10);
    },
    formatNumber,
    fetch() {
      var data = {
        live_id: this.dsId,
        live_type: 1,
      };
      this.axios
        .post(
          tool.getTestSchoolApi() + "/fansCoupon/getMyFansLiveCouponList",
          qs.stringify(data)
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.watchData = res.data.data.watchStatus;
            const totalTime = this.watchData.second_time;
            console.log(totalTime, "总时长");
            res.data.data.list.forEach((ele) => {
              if (ele.get_condition == 2 && !ele.is_satisfy) {
                if (ele.watch_time * 60 <= totalTime) {
                  ele.lookTime = ele.watch_time;
                  ele.is_satisfy = true;
                } else {
                  ele.is_satisfy = false;
                  ele.lookTime =
                    Math.floor(totalTime / 60) < 0
                      ? 0
                      : Math.floor(totalTime / 60);
                }
              }
            });
            // 调用计时器
            this.setLookTime && clearInterval(this.setLookTime);
            this.setLookTime = null;
            this.lookingTime = 0;
            // 开始直播了
            this.setLookTime = setInterval(() => {
              this.lookingTime += 1;
            }, 1000);
            this.dataList = res.data.data.list;
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    isShowHide(item, code) {
      this.$set(item, code, item[code]);
      item[code] = !item[code];
    },
    copyTextTap(text) {
      // 复制过滤
      // eslint-disable-next-line no-useless-escape
      let reg = /\<a(.*?)\>(\S*)\<\/a>/;
      let resultArr = text.match(reg);
      if (resultArr && resultArr[2]) {
        text = resultArr[2];
      }

      var oInput = document.createElement("input"); // 创建一个隐藏input（重要！）
      oInput.value = text; // 赋值
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象
      document.execCommand("Copy"); // 执行浏览器复制命令
      oInput.style.display = "none";
      document.body.removeChild(oInput);
      this.$message.success("复制成功");
    },
    // 立即领取
    receiveCoupon(row) {
      var params = {
        coupon_id: row.id,
        live_type: 1,
        live_id: this.dsId,
        channel_id: this.channelId,
      };
      this.axios
        .post(
          tool.getTestSchoolApi() + "/fansCoupon/receiveCoupon",
          qs.stringify(params)
        )
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success("领取成功");
            this.$set(row, "state", 1);
            this.$set(
              row,
              "verification_code",
              res.data.data.verification_code
            );
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    gotoUse(row) {
      if (!compareDate(row.start_time)) {
        this.$message({
          type: "error",
          message: "活动暂未开始，请耐心等待",
        });
        this.fetch();
        return;
      }
      if (compareDate(row.end_time)) {
        this.$message({
          type: "error",
          message: "优惠券已过期",
        });
        this.fetch();
        return;
      }
      if (row.goods_list && row.goods_list.length) {
        var arr = [];
        arr = row.goods_list;
        this.$emit("gotoUse", arr);
      } else {
        this.$message.error("请联系老师进行使用");
      }
    },
  },
  beforeDestroy() {
    if (this.setLookTime) {
      clearInterval(this.setLookTime);
      this.setLookTime = null;
    }
  },
};
</script>

<style scoped>
.banyuan {
  width: 5px;
  height: 10px;
  border: 1px solid #ff6827;
  z-index: 10000;
  border-right: 1px solid #fff;
  background: #ffffff;
  border-radius: 50px 0 0 50px;
  position: absolute;
  right: -5px;
  top: -4px;
}
.banyuaner {
  width: 5px;
  height: 10px;
  border: 1px solid #ff6827;
  z-index: 10000;
  border-left: 1px solid #fff;
  background: #ffffff;
  border-radius: 0 50px 50px 0;
  position: absolute;
  left: -5px;
  top: -4px;
}
.listBox {
  height: 100%;
}
.header {
  width: 100%;
  height: 40px;
  margin-bottom: 20px;
  display: flex;
  font-size: 14px;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
}
.couponList {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  height: calc(100% - 80px);
  overflow-y: auto;
  padding: 0 14px;
  position: relative;
}
.couponLi {
  margin-bottom: 12px;
  font-size: 12px;
  padding: 12px 10px 12px;
  background: #fff7f3;
  border: 0.6px solid #ff6827;
  border-radius: 8px;
  position: relative;
}
.limit-con {
  position: absolute;
  left: 0px;
  top: 0px;
  padding: 0 16px;
  height: 18px;
  background: #ffe7db;
  color: #ff6827;
  border-radius: 7px 0px 7px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.limit-con span {
  font-size: 10px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
}
.couponLi .top {
  display: flex;
  padding: 10px 0;
  box-sizing: border-box;
}
.toplist {
  display: flex;
  /* padding-bottom: 10px; */
}
.toplist .top-left {
  width: 70px;
  display: flex;
  margin-right: 10px;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  /* background: linear-gradient(137deg,#ffc101 98%, #ff9416 100%); */
  -webkit-background-clip: text;
  background-clip: text;
  /* color: transparent; */
  color: #ff6827;
}
.toplist .top-left .money {
  font-size: 14px;
  height: 28px;
  line-height: 36px;
}
.toplist .top-right {
  flex: 1;
}
.top .top-left {
  width: 70px;
  display: flex;
  margin-right: 10px;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  /* background: linear-gradient(137deg,#ffc101 98%, #ff9416 100%); */
  -webkit-background-clip: text;
  background-clip: text;
  /* color: transparent; */
  color: #ff6827;
}
.top .top-left .money {
  font-size: 14px;
  height: 28px;
  line-height: 36px;
}
.top .top-right {
  flex: 1;
}
.top-right .titleBox {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.titleBox .title {
  font-size: 14px;
  color: #202020;
  font-weight: bold;
  width: 68%;
  line-height: 20px;
  word-break: break-all;
  word-wrap: break-word;
  text-align: justify;
}
.titleBox .btn {
  width: 64px;
  height: 26px;
  line-height: 26px;
  color: #fff;
  font-size: 12px;
  border-radius: 13px;
  text-align: center;
  cursor: pointer;
  background: linear-gradient(293deg, #fc692f 0%, #fcaf40 100%);
  position: absolute;
  margin-left: 160px;
  margin-top: 48px;
}
.titleBox .touse {
  border: 1px solid #ff6827;
  background: none;
  color: #ff6827;
  position: absolute;
  margin-left: 160px;
  margin-top: 48px;
}
.titleBox .claimed {
  cursor: initial;
  background: #cccccc;
  color: #ffffff;
}
.top-right .time {
  margin-top: 10px;
  color: rgba(36, 37, 38, 0.5);
  text-align: left;
  font-size: 11px;
}
.top-right .checkCode {
  margin-top: 10px;
  display: flex;
}
.top-right .checkCode p {
  display: flex;
  align-items: center;
  color: rgba(36, 37, 38, 0.5);
}
.top-right .checkCode .operation {
  margin-left: 10px;
  width: 42px;
  display: flex;
  justify-content: space-between;
}
.top-right .checkCode .operation img {
  width: 16px;
}
/* 分割线 */
.line-con {
  position: relative;
  height: 1px;
  width: 104%;
  margin-left: -6px;
  border-bottom: 1px dashed rgba(255, 104, 39, 0.2);
}
.bottom {
  margin-top: 10px;
  color: rgba(36, 37, 38, 0.5);
  display: flex;
}
.bottom span {
  flex: 1;
  margin-right: 5px;
  padding-right: 5px;
  line-height: 16px;
  word-break: break-all;
  word-wrap: break-word;
  text-align: justify;
}
.bottom .whiteSpace {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.bottom img {
  width: 10px;
  height: 10px;
}
.curImg {
  cursor: pointer;
}

/* 空数据样式 */
.empty-data {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
  height: 420px;
}
.empty-data img {
  width: 156px;
}
.empty-data .empty-text {
  font-size: 14px;
  color: #979ca3;
  margin-top: 10px;
}

/* 修改滚动条的样式 */
/* 滚动条整体样式 */
::-webkit-scrollbar {
  width: 4px; /* 滚动条宽度 */
  height: 58px;
  padding-left: 10px;
}

/* 滚动条轨道样式 */
::-webkit-scrollbar-track {
  background: #f8f7f7; /* 滚动条轨道背景色 */
}

/* 滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.18); /* 滚动条滑块颜色 */
  border-radius: 6px; /* 滑块圆角 */
}

/* 鼠标悬停在滑块上的样式 */
::-webkit-scrollbar-thumb:hover {
  background: #727171; /* 悬停时的颜色 */
}
</style>



// WEBPACK FOOTER //
// src/components/couponsComponents/couponsList.vue